import React from "react";
import { usePermissionTabs } from "../../hooks/usePermissionTabs";
import { PermissionTabManager } from "../../components/PermissionTabManager";
import UnifiedManifestTab from "./_components/UnifiedManifestTab";
import ProductManifestTab from "./_components/ProductManifestTab";

const ALL_TABS = [
  {
    key: "All Manifests",
    label: "All Manifests",
    component: <UnifiedManifestTab />,
    modules: ["pickup_manifests", "linehaul_manifests", "return_to_shipper", "product_manifest"],
    operation: "read",
  },
  // {
  //   key: "Product Manifest",
  //   label: "Product",
  //   component: <ProductManifestTab />,
  //   modules: ["product_manifest"],
  //   operation: "read",
  // },
];

const ManifestManagement: React.FC = () => {
  const [mainHeaderButtons, setMainHeaderButtons] = React.useState<React.ReactNode>(null);
  const result = usePermissionTabs({ tabs: ALL_TABS, param: "tab" });

  const clonedContent =
    result.content && React.isValidElement(result.content)
      ? React.cloneElement(result.content as React.ReactElement, {
          setHeaderButtons: setMainHeaderButtons,
        } as any)
      : result.content;

  return (
    <PermissionTabManager
      visibleTabs={result.visibleTabs}
      activeLabel={result.activeLabel}
      content={clonedContent}
      isLoading={result.isLoading}
       activeClassName="bg-[#000] text-[#FFFFFF] font-bold shadow-sm"
      error={result.error}
      handleChange={result.handleChange}
      headerButtons={mainHeaderButtons}
    />
  );
};

export default ManifestManagement;
